import { render, staticRenderFns } from "./Deployment.vue?vue&type=template&id=4d76f1e2&scoped=true&"
import script from "./Deployment.vue?vue&type=script&lang=js&"
export * from "./Deployment.vue?vue&type=script&lang=js&"
import style0 from "./Deployment.vue?vue&type=style&index=0&id=4d76f1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76f1e2",
  null
  
)

/* custom blocks */
import block0 from "./Deployment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems})
